/**
 * Pure helpers for auth-context. Extracted so they can be unit-tested
 * without booting the React tree.
 */

/**
 * Type guard rejecting any string that is not a same-origin internal path.
 *
 * Blocks open-redirect vectors:
 * - protocol-relative `//evil.com`
 * - backslash variant `/\evil.com` (some legacy parsers treat as `//`)
 * - explicit `/javascript:` payloads
 * - absolute URLs (`https://...`, `javascript:...`)
 * - empty / null
 */
export const isSafeInternalUrl = (u: string | null | undefined): u is string =>
    !!u &&
    u.startsWith('/') &&
    !u.startsWith('//') &&
    !u.startsWith('/\\') &&
    !u.toLowerCase().startsWith('/javascript:');
